export { default } from './FullScreen';
